import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { FHEDivider } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { ApplianceIconComponent } from 'data/common/iconsvg';
import memoizeOne from 'memoize-one';
import DetailExpansionPanel from '../../../ProductModule/DetailExpansionPanel';
import DetailExpansionPanelRow from '../../../ProductModule/DetailExpansionPanelRow';
import { updateProductField } from '../../../../../../data/Products/actions';
import SvgSDM19INL from '../../../../../../../../data/common/iconsvg/SvgSDM19INL';
import InelioAlarms from './components/InelioAlarms';

class SDM19INL extends PureComponent {
    static propTypes = {
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        filteredProductModules: PropTypes.object,
        fheCenter_mac: PropTypes.string.isRequired,
        product_identifier: PropTypes.string.isRequired,
        mode: PropTypes.string,
        productType: PropTypes.string,
        type: PropTypes.string,
        productKey: PropTypes.string,
        updateProductField: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
    };

    static defaultProps = {
        mode: null,
        filteredProductModules: null,
        productType: null,
        type: null,
        productKey: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            formDisabled: true,
            sendLoading: false,
            form: {
                type: null,
                brand: null,
                energyClass: null,
                label: null,
                year: null,
            },
            expanded: null,
        };
        this.modes = [
            { value: 'triphase', label: Translator.translate('general.productModules.triphase') },
            { value: 'monophase', label: Translator.translate('general.productModules.monophase') },
        ];
    }

    static getDerivedStateFromProps(props, state) {
        const { formDisabled } = state;
        const { mode } = props;
        if (formDisabled) {
            let form = {
                mode: state.form.mode,
            };
            if (props.mode !== state.form.mode) {
                form.mode = mode;
            }
            return {
                form: form,
            };
        } else {
            return null;
        }
    }

    handleEdit = () => {
        const { formDisabled } = this.state;
        this.setState({
            formDisabled: !formDisabled,
        });
    };

    handleChangeSelect = event => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [event.target.name]: event.target.value },
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { mode } = this.props;
        this.setState({
            formDisabled: true,
            sendLoading: false,
            form: {
                mode: mode,
            },
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v })),
        );
    };

    confirmEdit = () => {
        const { form } = this.state;
        const { updateProductField, match, type, history } = this.props;

        this.setState({
            sendLoading: true,
            formDisabled: true,
        });

        return updateProductField('mode', match.params.homeId, match.params.productIdentifier, match.params.productType, form.mode, type)
            .then(() => {
                Toastr.success(Translator.translate(`generic.products.actions.editProductModuleSuccess`));
                this.loadInputs();
            })
            .catch(() => {
                this.setState({
                    sendLoading: false,
                    formDisabled: false,
                });
                Toastr.error(Translator.translate(`generic.products.actions.editProductModuleError`));
            });
    };

    handleChange = panel => {
        const { expanded } = this.state;
        if (expanded === panel) {
            this.setState({
                expanded: null,
            });
        } else {
            this.setState({
                expanded: panel,
            });
        }
    };

    handleClick = () => {
        this.setState({
            formDisabled: false,
        });
    };

    productModulesRender = lines => {
        const { productKey } = this.props;
        const { expanded } = this.state;
        let data = [];

        lines.forEach((line, key) => {
            data.push(
                <DetailExpansionPanelRow
                    key={key}
                    moduleKey={key}
                    expanded={expanded}
                    handleChange={this.handleChange.bind(this, key)}
                    line={line}
                    lineType={line.get('lineType')}
                    lineLabel={line.get('label')}
                    productKey={productKey}
                    isSDM19INL
                />,
            );
        });
        return data;
    };

    productModuleCategoriesRender = () => {
        const { filteredProductModules, theme, productType, type, history } = this.props;
        let data = [];

        if (filteredProductModules) {
            if (type === 'SDM19INL') {
                filteredProductModules.forEach((lines, key) => {
                    data.push(
                        <DetailExpansionPanel
                            key={key}
                            headerTitle={Translator.translate('general.products.SDM19INL.slaves')}
                            headerSvg={<SvgSDM19INL />}
                        >
                            {this.productModulesRender(lines)}
                        </DetailExpansionPanel>,
                    );
                });
            } else {
                filteredProductModules.forEach((lines, key) => {
                    data.push(
                        <DetailExpansionPanel
                            key={key}
                            headerTitle={Translator.translate(`general.productModules.${key}`)}
                            headerSvg={
                                <ApplianceIconComponent
                                    productType={productType}
                                    moduleType={type}
                                    productLineType={key}
                                    size={40}
                                    color={theme.palette.common.white}
                                    secondaryColor={theme.palette.primary.main}
                                />
                            }
                        >
                            {this.productModulesRender(lines)}
                        </DetailExpansionPanel>,
                    );
                });
            }
        }

        return data;
    };

    getSelectedMode = memoizeOne(mode => {
        return this.modes.find(x => x.value === mode);
    });

    handleReactSelect = (event, options) => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [options.name]: event.value },
        });
    };

    render() {
        const { fheCenter_mac, product_identifier } = this.props;
        return (
            <Fragment>
                <FHEDivider title={Translator.translate(`general.productModules.title`)} />
                <InelioAlarms product_identifier={product_identifier} fheCenter_mac={fheCenter_mac} />
                {this.productModuleCategoriesRender()}
            </Fragment>
        );
    }
}

function productModulesFilter(productModules) {
    let filteredProductModules = new Map();
    productModules.map((productModule, productModuleKey) => {
        filteredProductModules = filteredProductModules.mergeIn([productModule.get('lineType'), productModuleKey], productModule);
    });
    return filteredProductModules;
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    const productModules = state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'], new Map());
    let fheCenter_mac = null;
    state.environments[history.environment].data.Boxes.get('list').map((box, macAddress) => {
        if (box.get('homeId') === product.get('homeId')) fheCenter_mac = macAddress;
    });
    return {
        profile: state.data.user,
        productKey: productKey,
        productType: product.get('productType'),
        type: product.get('type'),
        mode: product.get('mode'),
        filteredProductModules: productModulesFilter(productModules),
        fheCenter_mac,
        product_identifier: product.get('identifier'),
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20,
    },
});

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/Product/Fhe/SDM19INL/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductField,
                    }),
                    dispatch,
                ),
        )(withStyles(styles, { withTheme: true })(SDM19INL)),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM19INL/index.js